const metadata = {
  id: 5,
  name: `How to Use Digital Case Studies for Learning`,
  metadata: {
    description: [],
    objectives: [],
    themes: [],

  },
  image:
    "https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/pexels-rdne-6517274.jpg",
  slug: "how-to-use-digital-case-studies-for-learning",
  title: `How to Use Digital Case Studies for Learning`,
}

export default metadata;